import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { apiConnector } from "../apiConnector";
import { endpoint } from "../apis";
import { setYoutubeChannels } from "../../slices/youtubeSlice";
import { useNavigate } from "react-router-dom";
import { clearChartData } from "src/store/slices/videoPerformanceSlice";
import { clearYoutubeChannelData } from "../../slices/youtubeSlice";
import { fetchYoutubeChannels } from "./youtubeAPI";
import Cookies from "js-cookie";

// AsyncThunk to fetch youtube channels
export const fetchUsersListFromDb = createAsyncThunk(
  "userSettings/fetchUsersListFromDb",
  async (_, { rejectWithValue }) => {
    const token = Cookies.get("authToken");

    try {
      const response = await apiConnector(
        "get",
        endpoint.GET_USERS_LIST,
        null,
        { Authorization: `Bearer ${token}` },
        null
      );

      if (Array.isArray(response.data.response.Users)) {
        if (response.data.response.Users.length === 0) {
          toast.success("No User found!!");
        } else {
          toast.success("User data fetched successfully!");
          return response.data;
        }
      } else {
        toast.error(
          "Failed to fetch User Data, or the data is not in the expected format!"
        );
      }
    } catch (error) {
      console.log("userError", error?.message);
      // Check if the error response indicates token expiration
      if (error?.message == "('Token has been expired',)") {
        localStorage.clear();
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error?.message || "Failed to fetch channels!");
      }
      return rejectWithValue(error?.message);
    }
  }
);

export const backToSession = createAsyncThunk(
  "userSettings/backToSession",
  async (navigate, { dispatch, rejectWithValue }) => {
    const impersonation_token = Cookies.get("jwt_token");
    const adminToken = Cookies.get("authToken");
    try {
      const response = await apiConnector(
        "post",
        endpoint.BACK_TO_SESSION,
        {
          user_token: impersonation_token,
          saved_admin_token: adminToken,
        },
        // {
        //     Authorization: `Bearer ${token}`
        // },
        null
      );

      if (response) {
        navigate("/user-settings");
        Cookies.remove("jwt_token");
        window.dispatchEvent(new Event("storage"));
        dispatch(clearChartData());
        dispatch(clearYoutubeChannelData());
        dispatch(fetchYoutubeChannels());
        toast.success("Back to AdminSession successfully!");
        return response.data;
      }
    } catch (error) {
      console.log("error", error?.response?.data);
      if (error?.response?.data == "('Token has been expired',)") {
        Cookies.remove("jwt_token");
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(
          error?.response?.data || "Failed to go back to Admin Session!"
        );
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const validateChannel = createAsyncThunk(
  "userSettings/validateChannel",
  async (
    { impersonation_token, accountName, navigate },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await apiConnector(
        "post",
        endpoint.VALIDATE_CHANNEL,
        {
          Impersonation_Token: impersonation_token,
          Account_Name: accountName,
        },
        {
          Authorization: `Bearer ${Cookies.get("jwt_token")}`,
          // Authorization: `Bearer ${impersonation_token}}`
        },
        null
      );
      console.log("response in validate channel", response);
      if (response) {
        toast.success("Channel validation successful!");
        dispatch(setYoutubeChannels(response?.data?.response));
        navigate("/audience-insights");
        return response?.data;
      } else {
        toast.error("Failed to validate channel!");
      }
    } catch (error) {
      console.log("validateChannel_error", error);
      if (error?.response?.data == "('Token has been expired',)") {
        Cookies.remove("jwt_token");
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error?.response?.data || "Failed to fetch channels!");
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const masterLogin = createAsyncThunk(
  "userSettings/masterLogin",
  async ({ email, accountName }, { dispatch, rejectWithValue }) => {
    // const token = localStorage.getItem('token');
    const token = Cookies.get("authToken");
    const prevImpersonationToken = localStorage.getItem("jwt_token");
    try {
      const response = await apiConnector(
        "post",
        endpoint.MASTER_LOGIN,
        {
          Email: email,
          // AccountId: accountId,
          Accountname: accountName,
          token: token,
          scopes: ["read", "write", "admin"],
        },
        {
          Authorization: `Bearer ${token}`,
        },
        null
      );
      // if (response) {
      //     dispatch(
      //         validateChannel({
      //             impersonation_token: response?.data?.impersonation_token,
      //             accountName: "sowmyas_corner",
      //         })
      //     );
      // }

      if (response) {
        if (prevImpersonationToken !== response?.data?.impersonation_token) {
          dispatch(clearChartData());
          window.dispatchEvent(new Event("storage"));
        }
        toast.success("Token generated successfully!");
      }

      return response?.data?.impersonation_token;
    } catch (error) {
      console.log("error", error?.response?.data);
      if (error?.response?.data == "('Token has been expired',)") {
        Cookies.remove("jwt_token");
        window.location.href = "/";
        toast.error("Session expired. Please log in again.");
      } else {
        toast.error(error?.response?.data || "Failed to fetch channels!");
      }
      return rejectWithValue(error?.response?.data);
    }
  }
);
